import { render, staticRenderFns } from "./jurisdictionUser.vue?vue&type=template&id=47096eca&scoped=true&"
import script from "./jurisdictionUser.vue?vue&type=script&lang=js&"
export * from "./jurisdictionUser.vue?vue&type=script&lang=js&"
import style0 from "./jurisdictionUser.vue?vue&type=style&index=0&id=47096eca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47096eca",
  null
  
)

export default component.exports